$(function () {
  $('ul.nav.navbar-nav').children('.menu-item').each(function () {
    $(this).toggleClass('submenu',($(this).find('ul.collapse').length > 0));

    if($(this).hasClass('submenu') && $(this).hasClass('active')) {
      $(this).find('ul.collapse').collapse('show');
      $(this).find('.dropdown-btn').html('-');
    }
  })

  $('nav.navbar').on('click','.navbar-toggle',function (e) {
    if($(this).hasClass('collapsed')) {
      $('nav.navbar .fullscreen-navigation').css('top','0');
      $('body').css('overflow','hidden');
      $('nav.navbar').find('.navbar-brand svg, .menu-burger .navbar-toggle').toggleClass('darkened',true);
    } else {
      $('nav.navbar .fullscreen-navigation').css('top','');
      $('body').css('overflow','');
      $('nav.navbar').find('.navbar-brand svg, .menu-burger .navbar-toggle').toggleClass('darkened',false);
    }
    $(this).toggleClass('collapsed');
  })

  $('li.menu-item').on('click','.dropdown-btn',function (e) {
    if($(this).hasClass('collapsed')) {
      $(this).html('-');
    } else {
      $(this).html('+');
    }
    var _this = this;

    $('ul.nav.navbar-nav').children('.menu-item').each(function () {
      $(this).find('ul.collapse').collapse('hide');
      $(this).find('.dropdown-btn').not(_this).html('+');
    })
  }).on('click','.dummy-link',function (e) {
    $(this).siblings('.dropdown-btn').trigger('click');
  })
});
